import { Store } from 'react-notifications-component';
import { ReactElement } from 'react';

const SETTINGS = {
	insert: 'bottom',
	container: 'bottom-right',
	animationIn: ['animate__animated', 'animate__fadeIn'],
	animationOut: ['animate__animated', 'animate__fadeOut'],
	dismiss: {
		duration: 5000,
		pauseOnHover: true,
		onScreen: true,
		showIcon: true,
		waitForAnimation: true,
	},
};

const showNotification = (title: string | ReactElement, message: string | ReactElement, type = 'default'): void => {
	Store.addNotification({
		title,
		message,
		// @ts-ignore
		type,
		...SETTINGS,
	});
};

export default showNotification;
